import React from "react";
import { Form } from "antd";

// @ts-ignore
export const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

export const EditableFormRow = Form.create()(EditableRow);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/EditableTable/EditableFormRow.tsx